export const LOADING_LOCALE_ZHCHT = {
    message: 'æ­£å¨å è¼ï¼è«ç¨å...'
};
